module.exports = __webpack_public_path__ + "static/media/Ellipse 1.209579b1.png";